import { useCallbackRef as e } from "./use-callback-ref.js";
import { useEffect as t, useRef as n } from "react";
// src/design/forms/datepicker/hooks/use-outside-click.ts
function r(r) {
	let { ref: o, handler: s, enabled: c = !0 } = r, l = e(s), u = n({
		isPointerDown: !1,
		ignoreEmulatedMouseEvents: !1
	}).current;
	t(() => {
		if (!c) return;
		let e = (e) => {
			i(e, o) && (u.isPointerDown = !0);
		}, t = (e) => {
			u.ignoreEmulatedMouseEvents ? u.ignoreEmulatedMouseEvents = !1 : u.isPointerDown && s && i(e, o) && (u.isPointerDown = !1, l(e));
		}, n = (e) => {
			u.ignoreEmulatedMouseEvents = !0, s && u.isPointerDown && i(e, o) && (u.isPointerDown = !1, l(e));
		}, r = a(o.current);
		return r.addEventListener("mousedown", e, !0), r.addEventListener("mouseup", t, !0), r.addEventListener("touchstart", e, !0), r.addEventListener("touchend", n, !0), () => {
			r.removeEventListener("mousedown", e, !0), r.removeEventListener("mouseup", t, !0), r.removeEventListener("touchstart", e, !0), r.removeEventListener("touchend", n, !0);
		};
	}, [
		s,
		o,
		l,
		u,
		c
	]);
}
function i(e, t) {
	let n = e.composedPath?.()[0] ?? e.target;
	return n && !a(n).contains(n) ? !1 : !t.current?.contains(n);
}
function a(e) {
	return e?.ownerDocument ?? document;
}
export { r as useOutsideClick };

//# sourceMappingURL=use-outside-click.js.map